<div class="row py-5 border-bottom">
  <div class="col-md-2">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 0"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 0" (click)="switchTo(0)">Antigüedad<br>
      Colaborador
    </button>
  </div>
  <div class="col-md-2">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 1"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 1" (click)="switchTo(1)">Fechas<br>De
      Ciclo
    </button>
  </div>

  <div class="col-md-3">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 2"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 2" (click)="switchTo(2)">
      Monto y Porcentajes<br> De Préstamo
    </button>
  </div>

  <div class="col-md-3">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 3"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 3" (click)="switchTo(3)">Tipos De
      Nomina<br>Incluidas
    </button>
  </div>

  <div class="col-md-2">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 4"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 4" (click)="switchTo(4)">
      Recuperación<br>Préstamos
    </button>
  </div>
</div>

<div *ngIf="contentLocation.savingParametersIndex == 0">
  <div class="my-5 row">
        <div class="col-md-4">
          <mat-form-field>
            <input matInput placeholder="Inicio (En Años):" type="number"
            [(ngModel)]="modParameter.applicableSeniorityRange.start" #weeksControl="ngModel" min="0"
              [min]="0" [max]="100000" onkeypress="return event.charCode >= 48 && event.charCode <= 57" required>
            <mat-error *ngIf="weeksControl?.errors?.required">Es necesario especificar el número de años.
            </mat-error>
            <mat-error *ngIf="weeksControl?.errors?.min">El número de años debe de ser mayor a -1.</mat-error>
            <mat-error *ngIf="weeksControl?.errors?.max">El número de años debe de ser menor a 100000.</mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-4">
          <mat-form-field>
            <input matInput placeholder="Fin (En Años):" type="number"
            [(ngModel)]="modParameter.applicableSeniorityRange.end" #biWeeksControl="ngModel" min="1"
              [min]="1" [max]="100000" onkeypress="return event.charCode >= 48 && event.charCode <= 57" required>
            <mat-error *ngIf="biWeeksControl?.errors?.required">Es necesario especificar el número de catorcenas.
            </mat-error>
            <mat-error *ngIf="biWeeksControl?.errors?.min">El número de años debe de ser mayor a 1.</mat-error>
            <mat-error *ngIf="biWeeksControl?.errors?.max">El número de años debe de ser menor a 100000.</mat-error>
          </mat-form-field>
        </div>
  </div>
</div>

<div *ngIf="contentLocation.savingParametersIndex == 1">

  <div class="row">

    <div class="col-md-4">
      <mat-form-field>
        <input matInput [matDatepicker]="inicioDeCicloPicker" placeholder="Inicio De Préstamos:"
          (dateChange)="setRegistrationDate('starts', $event)" [value]="newRLoanDate.startDate">
        <mat-datepicker-toggle matSuffix [for]="inicioDeCicloPicker"></mat-datepicker-toggle>
        <mat-datepicker #inicioDeCicloPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <input matInput [matDatepicker]="finDeCicloPicker" placeholder="Fin De Préstamos:"
          (dateChange)="setRegistrationDate('ends', $event)" [value]="newRLoanDate.endDate"
          [min]="newRLoanDate.startDate">
        <mat-datepicker-toggle matSuffix [for]="finDeCicloPicker"></mat-datepicker-toggle>
        <mat-datepicker #finDeCicloPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <mat-select placeholder="Dia de la Semana:" [(value)]="newRLoanDate.scheduleDay">
          <mat-option>Seleccione el dia</mat-option>
          <mat-option *ngFor="let day of days" [value]="day.dateDay">
            {{day.dateString}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

  </div>

  <div class="row">
    <div class="col-md-4 offset-md-8 bottom-vertically">
      <button class="btn btn-block btn-primary" (click)="addDate()">Añadir</button>
    </div>
  </div>

  <div class="my-5 row border-top" *ngIf="modParameter && modParameter && modParameter.loanDates.length > 0">
    <div class="col-md-12">

      <mat-table #loanDatesTable class="table" [dataSource]="modParameter.loanDates">

        <ng-container matColumnDef="InicioPrestamo">
          <mat-header-cell *matHeaderCellDef>Inicio De Préstamo</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.startDate | date: 'mediumDate'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="FinPrestamo">
          <mat-header-cell *matHeaderCellDef>Fin De Préstamo</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.endDate ? (element.endDate | date: 'mediumDate') : ''}}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="day">
          <mat-header-cell *matHeaderCellDef> Dia </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.scheduleDay !== null ? scheduleDay(element.scheduleDay) :
            ''}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="active">
          <mat-header-cell *matHeaderCellDef> Fecha Activa </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox [(ngModel)]="element.active" [disabled]="false">Fecha Activa</mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="delete" class="center-text">
          <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
          <mat-cell *matCellDef="let index = index">
            <button mat-icon-button color="warn" (click)="deleteLoanDate(index)">
              <mat-icon aria-label="Delete">delete_outline</mat-icon>
            </button>

          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedLoanDatesColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedLoanDatesColumns;"></mat-row>

      </mat-table>

    </div>
  </div>

</div>

<div *ngIf="contentLocation.savingParametersIndex == 2">

  <div class="row mt-5">
    <div class="col-md-4">

      <mat-form-field>
        <input matInput placeholder="Meses Sueldo a Solicitar:" type="number" [(ngModel)]="modParameter.maxEmployeeWageLoan" min="1"  [min]="1"
          #maxEmployeeWageLoanControl="ngModel" onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 47" max="99"
          required>
        <mat-error *ngIf="maxEmployeeWageLoanControl?.errors?.required">Es necesario especificar el número de
          meses.
        </mat-error>
        <mat-error *ngIf="maxEmployeeWageLoanControl?.errors?.min">Como mínimo se debe de especificar 1 mes.
        </mat-error>
      </mat-form-field>

    </div>
  </div>

  <div class="row">

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="Porcentaje Semana Ahorrador:" type="number"
          [(ngModel)]="modParameter.weeklySavingInterestsRate" min="0.0001" max="1" [min]="0.0001" [max]="1"
          #weeklySavingInterestsRateControl="ngModel" step="0.0001" required>
        <mat-error *ngIf="weeklySavingInterestsRateControl?.errors?.required">Es necesario especificar el
          interés
          semanal.</mat-error>
        <mat-error *ngIf="weeklySavingInterestsRateControl?.errors?.min">El número debe de ser mayor a 0.0001 .
        </mat-error>
        <mat-error *ngIf="weeklySavingInterestsRateControl?.errors?.max">El número debe de ser menor al 1 .
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="Porcentaje Semana No Ahorrador:" type="number"
          [(ngModel)]="modParameter.weeklyNonSavingInterestsRate" min="0.0001" max="1" [min]="0.0001"
          [max]="1" #weeklyNonSavingInterestsRateControl="ngModel" step="0.0001" required>
        <mat-error *ngIf="weeklyNonSavingInterestsRateControl?.errors?.required">Es necesario especificar el
          interés
          semanal.</mat-error>
        <mat-error *ngIf="weeklyNonSavingInterestsRateControl?.errors?.min">El número debe de ser mayor a 0.0001
          .
        </mat-error>
        <mat-error *ngIf="weeklyNonSavingInterestsRateControl?.errors?.max">El número debe de ser menor al 1.
        </mat-error>
      </mat-form-field>
    </div>

  </div>

  <div class="row mb-5">

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="Porcentaje Catorcena Ahorrador:" type="number"
          [(ngModel)]="modParameter.biWeeklySavingInterestsRate" min="0.0001" max="1" [min]="0.0001"
          [max]="1" #biWeeklySavingInterestsRateControl="ngModel" step="0.0001" required>
        <mat-error *ngIf="biWeeklySavingInterestsRateControl?.errors?.required">Es necesario especificar el
          interés
          catorcena.</mat-error>
        <mat-error *ngIf="biWeeklySavingInterestsRateControl?.errors?.min">El número debe de ser mayor a 0.0001
          .
        </mat-error>
        <mat-error *ngIf="biWeeklySavingInterestsRateControl?.errors?.max">El número debe de ser menor al 1.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="Porcentaje Catorcena No Ahorrador:" type="number"
          [(ngModel)]="modParameter.biWeeklyNonSavingInterestsRate" min="0.0001" max="1" [min]="0.0001"
          [max]="1" #biWeeklyNonSavingInterestsRateControl="ngModel" step="0.0001" required>
        <mat-error *ngIf="biWeeklyNonSavingInterestsRateControl?.errors?.required">Es necesario especificar el
          interés catorcena.</mat-error>
        <mat-error *ngIf="biWeeklyNonSavingInterestsRateControl?.errors?.min">El número debe de ser mayor a
          0.0001
          .
        </mat-error>
        <mat-error *ngIf="biWeeklyNonSavingInterestsRateControl?.errors?.max">El número debe de ser menor al 1.
        </mat-error>
      </mat-form-field>
    </div>

  </div>

</div>

<div *ngIf="contentLocation.savingParametersIndex == 3">

  <div class="my-5 row">
    <div class="col-md-12">

      <mat-table #wageTable class="table" [dataSource]="logicService.dataManager.generalDataLoader.wages">

        <ng-container matColumnDef="wageID">
          <mat-header-cell *matHeaderCellDef>Id</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.wageID}}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="wageName">
          <mat-header-cell *matHeaderCellDef> Descripción: </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.wageName }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="active">
          <mat-header-cell *matHeaderCellDef> Tipo Activo </mat-header-cell>

          <mat-cell mat-cell *matCellDef="let element">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selectionWages.toggle(element) : null"
              [checked]="selectionWages.isSelected(element)"></mat-checkbox>
          </mat-cell>

        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedWageColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedWageColumns;"></mat-row>

      </mat-table>

    </div>
  </div>

</div>

<div *ngIf="contentLocation.savingParametersIndex == 4">

  <div class="row mt-5">

    <div class="col-md-12">

      <mat-table #installmentsTable class="table" [dataSource]="this.logicService.dataManager.parameterDataLoader.installments">

        <ng-container matColumnDef="installmentID">
          <mat-header-cell mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.installmentID}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="weeks">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Semana(s) </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.weeks}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="biWeeks">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Catorcena(s) </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.biWeeks}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="months">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Mes(es) </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.months}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="select">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            Selección
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let row">
            <mat-radio-button (click)="$event.stopPropagation()"
              (change)="$event ? selectionInstallments.toggle(row) : null"
              [checked]="selectionInstallments.isSelected(row)"></mat-radio-button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="delete" class="center-text">
          <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
          <mat-cell *matCellDef="let index = index">
            <button mat-icon-button color="warn" (click)="deleteInstallments(index)">
              <mat-icon aria-label="Delete">delete_outline</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedInstallmentsColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedInstallmentsColumns;"></mat-row>
      </mat-table>

    </div>

  </div>
  <div class="row mt-5">
    <div class="col-md-3 mt-4 ml-5">
      <mat-checkbox [checked]="isEndDate" (change)="activateEndDate($event.checked)" [disabled]="existDate">
        Agregar Fecha Límite
      </mat-checkbox>
    </div>
    <div class="col-md-3 mr-5">
      <mat-form-field >
        <input [(ngModel)]="dateMaxPayments" placeholder="Fecha Límite:" [disabled]="!isEndDate" matInput (dateChange)="setDateMaxPayments( $event)"
          [matDatepicker]="alternateInput">
        <mat-datepicker-toggle matSuffix [for]="alternateInput"></mat-datepicker-toggle>
        <mat-datepicker #alternateInput></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-md-3 mt-4 ml-5">
     <label>{{dateMaxPayments | date}} </label> 
    </div>
    <div class="col-md-1" *ngIf="existDate" >
      <button mat-icon-button color="warn" (click)="deleteDateLoan(dateMaxPayments)">
        <mat-icon aria-label="Delete">delete_outline</mat-icon>
      </button>
    </div>

  </div>

</div>
